'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var API_REQUEST = exports.API_REQUEST = 'API_REQUEST';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-api-request/dist/action_types.js
// module id = 137
// module chunks = 0